import React from "react";
import { Helmet } from "react-helmet";
import VideoBanner from "../components/Home/VideoBanner";
import Solutions from "../components/Home/solutions/Solutions";
import CallToAction from "../components/Home/CallToAction/CallToAction";
import WhoWeServe from "../components/Home/WhoWeServe/WhoWeServe";
import WhyUs from "../components/Home/WhyUs/WhyUs";
import AboutUs from "../components/Home/AboutUs/AboutUs";
import HomeCategories from "../components/Home/HomeCategories/HomeCategories";
import IconSection from "../components/IconSection/IconSection";
import FAQ from "../components/Home/Faq/Faq";
const Home = () => {
  const messages = [
"Brochures",
"Exhibition Design & Print",
"Brand Collaterals",
"Marketing Prints",
"Event Prints",
"Packaging Boxes",
"Catalogues",
"Standees",
"Flex Banners"
  ];
  return (
    <>
      <Helmet>
        <title>Printing Services customised | High-Quality Print Solutions</title>
        <meta name="description" content="Discover custom printing services for all industries. High-quality materials, large format prints, promotional items, packaging solutions, and more." />
        {/* <meta name="keywords" content="home, website, react" /> */}
        <link rel="canonical" href="https://printingy.com/" />
        {/* Add schema and FAQ schema here */}
      </Helmet>
      
     <VideoBanner
        videoSrc="/bannerVideo.mp4"
        posterImage="/path-to-poster.jpg"
        messages={messages}
      />
     
      <Solutions />
      <AboutUs />
      <IconSection />
      <WhoWeServe />
      <CallToAction 
        title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
      <WhyUs />
    
      <HomeCategories />
      <FAQ />
    </>
  );
};

export default Home;
